import { getShellConfig } from '@src/config/shell/config';
import { featureFlagService } from '@superbet-group/web.lib.flags';

export async function setPrerenderReadyState(value: boolean) {
    const enabled = await featureFlagService.getFeatureValue('prerender.ready-state', false);

    if (!enabled) {
        return;
    }

    setTimeout(() => {
        window.prerenderReady = value;
    }, getShellConfig().remoteConfig.prerenderReadyDelay);
}
